import React, { useState, useEffect } from "react";

import Sidebar from "../sidebar";
import Footer from "../footer";
import { getIsShowFullSidebar, setIsShowFullSidebar } from "../../storage";
import useCurrentLocation from "../hooks/useCurrentLocation";
import Navbar from "../navbar/navbar";

const Template = ({ children, is_current_job_page = false }) => {
    const { pathname } = useCurrentLocation();

    const is_full_sidebar = getIsShowFullSidebar();
    const [isFullSidebar, setIsFullSidebar] = useState(is_full_sidebar);

    useEffect(() => {
        setIsFullSidebar(pathname === "/create/jobs" ? false : is_full_sidebar);
    }, [pathname, is_full_sidebar]);

    const showFullSidebar = () => {
        setIsShowFullSidebar(!isFullSidebar);
        setIsFullSidebar(!isFullSidebar);
    };

    return (
        <React.Fragment>
            <div
                className={`g-sidenav-show bg-gray-100 g-sidenav-${isFullSidebar ? "pinned" : "hidden"}`}
                style={{ height: "100vh", display: "flex", flexDirection: "column" }}
            >
                {!is_current_job_page && <Sidebar isFullSidebar={isFullSidebar} setIsFullSidebar={setIsFullSidebar} />}
                <main
                    className="main-content position-relative border-radius-lg"
                    style={{
                        height: "100%",
                        flex: "1 1 auto",
                        overflow: "auto",
                    }}
                >
                    {!is_current_job_page && (
                        <Navbar
                            isFullSidebar={isFullSidebar}
                            setIsFullSidebar={showFullSidebar}
                            isCurrentJobPage={is_current_job_page}
                        />
                    )}
                    <div className="container-fluid py-4">{children}</div>
                    <Footer is_current_job_page={is_current_job_page} />
                </main>
            </div>
        </React.Fragment>
    );
};

export default Template;